import React from 'react';
import { Box, Typography, IconButton, Button, CircularProgress } from '@mui/material';
import { Refresh, Storage } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

interface CMSHeaderProps {
  refreshing: boolean;
  onRefresh: () => void;
  onOpenStorageDialog: () => void;
}

const CMSHeader: React.FC<CMSHeaderProps> = ({
  refreshing,
  onRefresh,
  onOpenStorageDialog,
}) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 3,
        flexDirection: { xs: "column", sm: "row" },
        gap: { xs: 2, sm: 0 },
      }}
    >
      <Typography
        variant="h3"
        component="h1"
        sx={{
          fontWeight: 800,
          background: "linear-gradient(135deg, #ff0080 0%, #00d4ff 100%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          fontSize: { xs: "1.75rem", sm: "2.25rem", md: "3rem" },
          textAlign: { xs: "center", sm: "left" },
        }}
      >
        {t("admin.contentManagement.title")}
      </Typography>
      <Box sx={{ display: "flex", gap: 1 }}>
        <IconButton
          onClick={onRefresh}
          disabled={refreshing}
          sx={{
            bgcolor: "rgba(0,212,255,0.1)",
            "&:hover": { bgcolor: "rgba(0,212,255,0.2)" },
          }}
        >
          {refreshing ? <CircularProgress size={24} /> : <Refresh />}
        </IconButton>
        <Button
          variant="outlined"
          size="small"
          startIcon={<Storage />}
          onClick={onOpenStorageDialog}
          sx={{
            borderColor: "#00d4ff",
            color: "#00d4ff",
            "&:hover": {
              borderColor: "#0099cc",
              bgcolor: "rgba(0,212,255,0.1)",
            },
          }}
        >
          {t("admin.contentManagement.storage.checkStorage")}
        </Button>
      </Box>
    </Box>
  );
};

export default CMSHeader;